module.exports = __webpack_public_path__ + "src/assets/audio/music.mp3";